import { AccessList, useHasAccess, useProvider } from '~/Hooks';
import { useRequest } from '~/Hooks/useRequest';
import { CORE_SERVICE_URLS } from '~/Constants/Urls.constants';
import { routeReplacer } from '~/Helpers/String.helper';

export const useUpdateUSCIntegration = () => {
  const { requestWithCallback } = useRequest();
  const { hasAccess } = useHasAccess();
  const isForcedEventGroupUSCSync = hasAccess(AccessList.FORCE_EVENT_GROUP_USC_SYNC);
  const { currentProvider } = useProvider();

  return {
    updateUSCIntegrationForEventGroup: async ({
      eventGroupId,
      isUSCIntegrationEnabled,
    }: {
      eventGroupId: string;
      isUSCIntegrationEnabled: boolean;
    }) => {
      if (currentProvider && !isForcedEventGroupUSCSync) {
        if (isUSCIntegrationEnabled) {
          await requestWithCallback({
            url: CORE_SERVICE_URLS.SYNCED_EVENT_GROUPS,
            method: 'POST',
            data: { providerId: currentProvider.uuid, eventGroupId },
          });
        } else {
          await requestWithCallback({
            url: routeReplacer(CORE_SERVICE_URLS.SYNCED_EVENT_GROUPS_BY_ID, { id: eventGroupId }),
            method: 'DELETE',
          });
        }
      }
    },
  };
};
